/* ============================================
   NOXOR — Premium Newsletter Enhancement
   ============================================ */
(function () {
  'use strict';

  function init() {
    var sections = document.querySelectorAll('.section-newsletter');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var newsletter = section.querySelector('.newsletter');
      if (!newsletter || newsletter.classList.contains('noxor-newsletter-done')) return;
      newsletter.classList.add('noxor-newsletter-done');

      /* — Wrap in premium container — */
      var wrap = document.createElement('div');
      wrap.className = 'noxor-newsletter-wrap';

      /* Top accent line */
      var topLine = document.createElement('div');
      topLine.className = 'noxor-newsletter-topline';
      wrap.appendChild(topLine);

      /* Inner content container */
      var inner = document.createElement('div');
      inner.className = 'noxor-newsletter-inner';

      /* Eyebrow */
      var eyebrow = document.createElement('span');
      eyebrow.className = 'noxor-newsletter-eyebrow';
      eyebrow.textContent = 'Stay in the Loop';
      inner.appendChild(eyebrow);

      /* Title */
      var title = document.createElement('h2');
      title.className = 'noxor-nl-title';
      title.textContent = 'Get Expert Roofing Tips & Exclusive Deals';
      inner.appendChild(title);

      /* Subtitle */
      var subtitle = document.createElement('p');
      subtitle.className = 'noxor-nl-subtitle';
      subtitle.textContent = 'Join thousands of property owners and contractors who trust Noxor for professional roof protection solutions.';
      inner.appendChild(subtitle);

      /* Move the form into inner */
      var formContainer = newsletter.querySelector('.form-newsletter_container');
      if (formContainer) {
        inner.appendChild(formContainer);
      }

      /* Trust line */
      var trust = document.createElement('div');
      trust.className = 'noxor-newsletter-trust';
      trust.innerHTML =
        '<span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' +
          'No spam, ever' +
        '</span>' +
        '<span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
          'Unsubscribe anytime' +
        '</span>' +
        '<span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
          'Your data is safe' +
        '</span>';
      inner.appendChild(trust);

      wrap.appendChild(inner);

      /* Replace original content */
      newsletter.innerHTML = '';
      newsletter.appendChild(wrap);

      /* Remove original newsletter styling interference */
      newsletter.style.minHeight = 'auto';
      newsletter.style.background = 'none';
      newsletter.style.padding = '0';

      /* Scroll reveal */
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('noxor-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      observer.observe(inner);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
